import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import useApi from "../../../CustomHooks/useApi";
import Popup from "../../../ResuableCompoment/Popup";
import { fetchAepsBalance, fetchSettlementBalance, fetchWalletBalance } from "../../../Store/Slices/WalletSlice";
import AddBeneficiaryUniversal from "../../../ResuableCompoment/AddBeneficiaryUniversal";

const AddBeneficiaryIMPS2 = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const remitter_mobile = location.state?.mobile;
  const remitter_name = location.state?.name;

  const username = useSelector(
    (s) => s.auth.employeeDetails?.username
  );

  const { callApi: addBene } = useApi("/dmt/add/beneficiary", "POST");
  const [isLoading, setIsLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("");


  const handleAddBeneficiary = async (data, onDone) => {
    try {
      setIsLoading(true);

      const payload = {
        remitterPhoneNumber: remitter_mobile,
        remitterName: remitter_name,
        beneficiaryName: data.beneficiaryName ? data.beneficiaryName : remitter_name,
        beneficiaryPhoneNumber: remitter_mobile,
        bankName: data.bank,
        bankIfscCode: data.ifsc,
        bank_code: data.bankCode,
        accountNumber: data.accountNumber,
        mpin: data.mpin,
        user_name: username,
        type: "IMPS2",
        account_verify: data.account_verify,
      };

      const res = await addBene(payload);

      if (res?.beneficiary_id) {
        setPopupMessage("Beneficiary added successfully");
        setPopupType("success");
        setShowPopup(true);

        dispatch(fetchWalletBalance());
        dispatch(fetchAepsBalance());
        dispatch(fetchSettlementBalance());
        if (typeof onDone === "function") {
          onDone();
        }

        setTimeout(() => {
          navigate(-1, { state: { fetchbeneficiares: true } });
        }, 800);
      } else {
        throw new Error(res?.message || "Failed to add beneficiary");
      }
    } catch (e) {
      setPopupMessage(e?.message || "Something went wrong");
      setPopupType("error");
      setShowPopup(true);
      if (typeof onDone === "function") {
        onDone();
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    // <div className="min-h-screen bg-gradient-to-br from-slate-50 via-indigo-50 to-cyan-50 py-6 px-3">
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-indigo-50 to-cyan-50 px-2 py-3 sm:px-6 sm:py-6">

      {/* ===== HEADER ===== */}
      {/* <div className="mb-6 text-center">
        <h2 className="text-2xl font-semibold text-slate-900">
          Add Beneficiary
        </h2>
        <p className="text-sm text-slate-600 mt-1">
          IMPS transfer beneficiary details
        </p>
      </div> */}
    
    
      {/* <div className="mb-3 text-center">
        <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900">
          Add Beneficiary
        </h2>
        <p className="text-base sm:text-lg text-slate-700 mt-1">
          IMPS transfer beneficiary details
        </p>
      </div> */}

      <AddBeneficiaryUniversal
        onSubmit={handleAddBeneficiary}
        loading={isLoading}
      />

      {showPopup && (
        <Popup
          message={popupMessage}
          type={popupType}
          onClose={() => setShowPopup(false)}
        />
      )}
    </div>
  );

};

export default AddBeneficiaryIMPS2;
